import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Checkbox } from 'semantic-ui-react';

import CommonTextInput from
    'components/elements/inputs/CommonTextInput';

import { fixURL } from 'utils/fixURL';

import './ImageSliderLink.css';

const ImageSliderLink = props => {
  const { t } = useTranslation();
  const { item, patchImageSlider, patchImageSliderError } = props;

  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('link_is_active', checked);
    patchImageSlider(item.id, form);
  };

  const changeValue = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    patchImageSlider(item.id, form);
  };

  const linkTextValidation = value => {
    const errors = [];
    if (value && value.length > 128) {
      errors.push(t("Ensure this field has no more than 128 characters"));
    }
    return errors;
  };

  const linkUrlValidation = value => {
    const errors = [];
    return errors;
  };

  return (
    <div className="image-slider-link__component">
      <div className="header">
        <div className="label">{t("Add Link")}</div>
        <div className="checkbox-wrapper">
          <div className="option">{t("OFF")}</div>
          <Checkbox
            toggle
            checked={item.link_is_active}
            onChange={onCheckboxChange}
          />
          <div className="option">{t("ON")}</div>
        </div>
      </div>

      {/* Content */}
      {item.link_is_active &&
        <div className="content">
          {/* Link Text */}
          <CommonTextInput
            key={`image-slider-description-link-text-input-key-${item.id}`}
            label={t("Link Text")}
            placeholder={t("Image Slider Link Text")}
            initValue={item.link_text}
            executedFunction={value => { changeValue('link_text', value); }}
            validationErrors={value => { return linkTextValidation(value); }}
            actionErrors={patchImageSliderError && patchImageSliderError.link_text}
          />

          {/* Link URL */}
          <CommonTextInput
            key={`image-slider-description-link-url-input-key-${item.id}`}
            label={t("Link URL")}
            placeholder={t("Image Slider Link URL")}
            url
            initValue={item.link_url}
            executedFunction={value => { changeValue('link_url', fixURL(value)); }}
            validationErrors={value => { return linkUrlValidation(fixURL(value)); }}
            actionErrors={patchImageSliderError && patchImageSliderError.link_url}
          />

        </div>
      }
    </div>
  );
};

ImageSliderLink.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  patchImageSliderError: PropTypes.object,
};

ImageSliderLink.defaultProps = {
  patchImageSliderError: null,
};

const mapStateToProps = state => (
  {
    patchImageSliderError: state.imageSlidersReducer.patchImageSliderError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchImageSlider,
  },
)(ImageSliderLink);
